(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();

    class CountdownBanner {
      constructor(container) {
        this.container = container;
        this.endDate = container.dataset.endDate;
        this.timer = container.querySelector('.countdown-banner__timer');
        this.expired = container.querySelector('.countdown-banner__expired');
        this.days = container.querySelector('[data-days]');
        this.hours = container.querySelector('[data-hours]');
        this.minutes = container.querySelector('[data-minutes]');
        this.seconds = container.querySelector('[data-seconds]');
        this.interval = null;

        if (!this.endDate) return;

        this.update();
        this.interval = window.setInterval(() => this.update(), 1000);
      }

      update() {
        const end = new Date(this.endDate).getTime();

        if (!Number.isFinite(end)) {
          this.stop();
          return;
        }

        const distance = end - Date.now();

        if (distance <= 0) {
          this.showExpired();
          return;
        }

        const days = Math.floor(distance / 86400000);
        const hours = Math.floor((distance % 86400000) / 3600000);
        const minutes = Math.floor((distance % 3600000) / 60000);
        const seconds = Math.floor((distance % 60000) / 1000);

        if (this.days) this.days.textContent = String(days).padStart(2, '0');
        if (this.hours) this.hours.textContent = String(hours).padStart(2, '0');
        if (this.minutes) this.minutes.textContent = String(minutes).padStart(2, '0');
        if (this.seconds) this.seconds.textContent = String(seconds).padStart(2, '0');
      }

      showExpired() {
        this.stop();
        if (this.timer) this.timer.hidden = true;
        if (this.expired) this.expired.hidden = false;
      }

      stop() {
        if (this.interval) {
          window.clearInterval(this.interval);
          this.interval = null;
        }
      }

      destroy() {
        this.stop();
      }
    }

    function init(root) {
      if (!root) return;
      if (instances.has(root)) return;
      instances.set(root, new CountdownBanner(root));
    }

    function destroy(root) {
      if (!root) return;
      const instance = instances.get(root);
      if (!instance) return;
      instance.destroy();
      instances.delete(root);
    }

    document.querySelectorAll('.countdown-banner[data-section-id]').forEach(init);

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target.querySelector('.countdown-banner[data-section-id]'));
    });

    document.addEventListener('shopify:section:unload', (event) => {
      destroy(event.target.querySelector('.countdown-banner[data-section-id]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
